<template>
  <div class="content">
    <navigation :navName="nav"></navigation>
    <template>
      <el-form ref="editForm"
               :model="editForm"
               class="mobile-show-box form-wrapper"
               :label-width="formLabelWidth"
               :rules='formRule'>
        <el-form-item prop='title'
                      label="图片标题">
          <el-input placeholder="请输入标题"
                    v-model="editForm.title"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="图片副标题">
          <el-input placeholder="请输入标题"
                    v-model="editForm.subTitle"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="图片缩略图">
          <div class="single-img-upload">
            <el-upload :action="imgUpload"
                       :class="{disabled:uploadDisabledIcon}"
                       list-type="picture-card"
                       :on-preview="handleIconCardPreview"
                       :on-success="handleIconSuccess"
                       :on-remove="handleRemoveIcon"
                       :before-upload="beforeAvatarUpload"
                       :file-list="iconList"
                       :headers="isOverSea">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisibleIcon">
              <img width="100%"
                   :src="dialogIconUrl"
                   alt="" />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item prop="main_img"
                      label="主图上传">
          <div class="single-img-upload">
            <el-upload :action="imgUpload"
                       :class="{disabled:uploadDisabledImage}"
                       list-type="picture-card"
                       :on-preview="handlePictureCardPreview"
                       :on-success="handlePictureSuccess"
                       :on-remove="handleRemoveImage"
                       :before-upload="beforeAvatarUpload"
                       :file-list="imgList"
                       :headers="isOverSea">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisibleImage">
              <img width="100%"
                   :src="dialogImageUrl"
                   alt="" />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    size="mini"
                    v-model="editForm.describe">
          </el-input>
        </el-form-item>
        <el-form-item label="文章跳转"
                      v-if="!editForm.url">
          <el-select v-model="editForm.column"
                     @change="getNextSelect"
                     clearable
                     size="mini"
                     placeholder="请选择">
            <el-option v-for="item in columns"
                       :key="item.name"
                       size="mini"
                       :label="item.name"
                       :value="item.name">
            </el-option>
          </el-select>
          <el-select v-model="editForm.article"
                     clearable
                     placeholder="请选择"
                     v-if="editForm.column.length>0">
            <el-option v-for="item in activityList"
                       :key="item._id"
                       :label="item.title"
                       :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转url"
                      v-if="!editForm.article">
          <el-input placeholder="请输入内容"
                    v-model="editForm.url"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="优先级排序">
          <el-input type="number"
                    min="0"
                    size="mini"
                    v-model="editForm.sort"
                    class="num-input">
          </el-input>
          <span class="warning-span">注：数字越小优先级越高</span>
        </el-form-item>
        <el-form-item label="是否发布">
          <el-radio v-model="editForm.release"
                    label="true">发布</el-radio>
          <el-radio v-model="editForm.release"
                    label="false">不发布</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button size="mini"
                     type="primary"
                     @click="addArt()">提交</el-button>
          <el-button size="mini"
                     @click="back()">取消</el-button>
        </el-form-item>
      </el-form>
    </template>
  </div>
</template>
<style lang="less">
.disabled .el-upload--picture-card {
  display: none;
}
</style>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import navigation from './navigation';
import api from '../../api/api';

export default {
  data() {
    return {
      editForm: {
        title: '',
        subTitle: '',
        describe: '',
        img: '',
        icon: '',
        article: '',
        url: '',
        release: 'false',
        sort: 0,
        column: '',
      },
      formLabelWidth: '90px',
      dialogImageUrl: '',
      dialogIconUrl: '',
      dialogVisibleIcon: false,
      dialogVisibleImage: false,
      imgUpload: `${api.url}upload`,
      uploadDisabledIcon: false,
      uploadDisabledImage: false,
      imgList: [],
      formRule: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        main_img: [{ required: true, message: '请上传图片', trigger: 'blur' }],
      },
      iconList: [],
      id: '',
      nav: '',
    };
  },
  created() {
    if (this.$store.state.imgId) {
      this.id = this.$store.state.imgId;
      axios.post(`${api.url}imgsDetail`, { id: this.$store.state.imgId }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          const content = data.content;
          this.editForm = content;
          this.editForm.release = `${content.release}`;
          if (content.icon) {
            this.uploadDisabledIcon = true;
            this.editForm.icon = content.icon;
            this.iconList = [{ url: this.$store.state.publicUrl + content.icon, status: 'finished' }];
          }
          if (content.img) {
            if (content.img) {
              this.uploadDisabledImage = true;
              this.editForm.img = content.img;
              this.imgList = [{ url: this.$store.state.publicUrl + content.img, status: 'finished' }];
            }
          }
          const msg = {
            type: this.editForm.column,
            wid: this.$store.state.websiteId,
            pageSize: 999999,
            release: true,
          };
          this.$store.dispatch('getArticle', msg);
        }
      });
    }
  },
  computed: {
    ...mapState([
      'columns',
      'activityList',
    ]),
    isOverSea() {
      const object = {};
      object.isOverSea = this.$store.state.is_overSea;
      return object;
    },
  },
  components: {
    navigation,
  },
  methods: {
    back() {
      this.$router.back(-1);
    },
    addArt() {
      if (this.editForm.title === '') {
        this.$message({
          message: '请填写标题',
          type: 'warning',
        });
        return;
      }
      if (this.editForm.img === '') {
        this.$message({
          message: '请先上传主图',
          type: 'warning',
        });
        return;
      }
      const data = Object.assign(this.editForm, {
        wid: this.$store.state.websiteId,
        type: this.$store.state.navName,
        id: this.id,

      });
      axios.post(`${api.url}addImages`, data).then((response) => {
        if (response.data.ret === 0) {
          this.$alert(response.data.msg, '', {
            confirmButtonText: '确定',
            callback: () => {
              const imgData = {
                type: this.$store.state.navName,
                wid: this.$store.state.websiteId,
              };
              this.$store.dispatch('getImages', imgData);
              window.history.back();
            },
          });
        }
      });
    },
    handleRemoveIcon() {
      this.uploadDisabledIcon = false;
      this.editForm.icon = '';
    },
    handleRemoveImage() {
      this.uploadDisabledImage = false;
      this.editForm.img = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleImage = true;
    },
    handleIconCardPreview(file) {
      this.dialogIconUrl = file.url;
      this.dialogVisibleIcon = true;
    },
    handlePictureSuccess(file) {
      if (file.ret === 0) {
        this.uploadDisabledImage = true;
        this.editForm.img = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    handleIconSuccess(file) {
      if (file.ret === 0) {
        this.uploadDisabledIcon = true;
        this.editForm.icon = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isGif = file.type === 'image/gif';
      if (!isJPG && !isPng && !isGif) {
        this.$message.error('上传图片只能是 JPG 格式,GIF格式 或者 PNG 格式!');
      }
    },
    // 根据栏目获取文章
    getNextSelect(val) {
      this.editForm.article = '';
      if (val) {
        const data = {
          type: val,
          wid: this.$store.state.websiteId,
          pageSize: 999999,
          release: true,
        };
        this.$store.dispatch('getArticle', data);
      } else {
        const data = {
          type: val,
          wid: this.$store.state.websiteId,
          pageSize: 999999,
          pageNum: 99999999,
          release: true,
        };
        this.$store.dispatch('getArticle', data);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/websiteConfig/addImg.vue